<template>
    <div class="w-full sm:w-6/12 lg:w-3/12 px-3 mb-8">
        <div class="bg-white block mx-auto w-full h-full accelerate max-w-md shadow-figure2 card-gallery">
            <div class="bg-white pt-5 pl-5 pb-8 pr-5 relative h-full">
                <div class="bg-porcelain min-h-150px relative">
                    <picture>
                        <img class="w-full block transition accelerate" :srcset="image.image1x + ' 1x, ' + image.image2x +' 2x'" :alt="image.alternateText" />
                    </picture>
                </div>
                <div class="pt-4 pb-2">
                    <p class="leading-relaxed text-sm text-shark">{{title}}</p>
                </div>
                <ul class="flex flex-col">
                    <li class="mb-2" v-for="tag in tags">
                        <a :href="tag.url" target="_blank" class="flex items-center">
                            <div>
                                <span :style="{'background-color': tag.color}" :title="tag.colorName" class="block w-5 h-5 rounded-full shadow-tag mr-2"></span>
                            </div>
                            <div>
                                <span class="text-xs text-shark">{{tag.label}}</span>
                            </div>
                        </a>
                    </li>
                </ul>
                <button :data-expand-gallery="slug" class="absolute button-circular">
                  <ExpandIcon  class="button-circular__icon" />

                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import ExpandIcon from '../../img/allura/icons-svg/expand.svg?component';
    import { normalizeFeaturedProducts } from '../../js/utils/gallery-runtime';
    export default  {
        name: 'GalleryCard',
        components: {
              ExpandIcon
        },
        props: {
            'project': Object
        },
        computed: {
            title() {
                return this.project.title;
            },
            slug() {
                return this.project.slug
            },
            image() {
               return this.project.galleryThumbnail;
            },
            tags() {
                return normalizeFeaturedProducts(this.project.featuredProducts?.data);
            }
        }
    }
</script>
